import type { AtLeast, Block } from '@basehub/data/replicache/index'

export function editorCanEditBlocks({
  blocks,
  parentBlock,
}: {
  parentBlock: AtLeast<Block, 'type'> | undefined
  blocks: AtLeast<Block, 'type' | 'instanceChildTarget'>[]
}) {
  if (!blocks.length) return false

  if (!parentBlock) {
    return false
  }
  if (parentBlock.type === 'instance') {
    // instance schemas cannot be altered directly, so we assume that this edit is
    // either a mutator side effect (syncInstanceWithComponent) or a valid user action
    return true
  }

  if (!['list', 'rich-text', 'reference'].includes(parentBlock.type)) {
    return false
  }

  for (const block of blocks) {
    if (block.type !== 'instance') {
      return false
    }
  }

  return true
}
